import { useLocaleContext } from '../../context/LocaleContext.js'
import type { UiLocale } from '../../core/contracts.js'

interface LocaleToggleProps {
  className?: string
}

export function LocaleToggle({ className }: LocaleToggleProps) {
  const { locale, setLocale, t } = useLocaleContext()

  const baseClass = className ?? 'future-locale-toggle'

  return (
    <div className={baseClass} role="group" aria-label={t('locale.toggleLabel')}>
      <span className="future-locale-toggle-label">{t('locale.toggleLabel')}</span>
      {(['en', 'nb'] as const satisfies readonly UiLocale[]).map(code => (
        <button
          key={code}
          type="button"
          className={`future-locale-toggle-btn${locale === code ? ' is-active' : ''}`}
          aria-pressed={locale === code}
          onClick={() => setLocale(code, { explicit: true })}
        >
          {code === 'en' ? t('locale.english') : t('locale.norwegian')}
        </button>
      ))}
    </div>
  )
}
